import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "", form_type: "master" });
  const submit = async () => {
    try { const { data } = await api.post("/contact", form); toast.success(`Thank you. Reference ${data.id}.`); setForm({ ...form, subject: "", message: "" }); }
    catch (e) { toast.error("Failed to send"); }
  };
  return (
    <main className="sq-container py-12" data-testid="contact-page">
      <div className="sq-eyebrow text-squire-jeans">Atelier</div>
      <h1 className="font-display text-5xl md:text-6xl mt-2">Master Contact</h1>
      <p className="text-[#4B5563] mt-3 max-w-xl">Get in touch with our master tailor — for bespoke, appointments, or any enquiry.</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-10 max-w-4xl">
        <div className="space-y-4">
          {[["name", "Your Name"], ["email", "Email"], ["phone", "Phone"], ["subject", "Subject"]].map(([k, l]) => (
            <label key={k} className="block">
              <span className="sq-eyebrow">{l}</span>
              <input data-testid={`contact-${k}`} value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="w-full bg-transparent border-b border-black/30 focus:border-squire-jeans outline-none py-2" />
            </label>
          ))}
          <label className="block">
            <span className="sq-eyebrow">Message</span>
            <textarea data-testid="contact-message" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full bg-transparent border-b border-black/30 focus:border-squire-jeans outline-none py-2 resize-none" />
          </label>
          <button data-testid="contact-submit" onClick={submit} className="sq-btn-primary">Send Message</button>
        </div>
        <div className="bg-black text-white p-10">
          <div className="sq-eyebrow text-white/60">Atelier</div>
          <div className="font-display text-3xl mt-2">SquireCouture House</div>
          <div className="mt-6 space-y-3 text-sm text-white/80">
            <div>76-6, Koppikar Rd, Kamaripeth, New Hubli, Hubballi, 580020</div>
            <div>concierge@squirecouture.com</div>
            <div>0836 226 8212</div>
            <div className="pt-4 sq-eyebrow text-white/60">Hours</div>
            <div>Sun – Sat 10:30 – 8:30</div>
          </div>
        </div>
      </div>
    </main>
  );
}
